<template>
  <div>
    <herder msg="智慧煤矿三维可视化系统" />
    <littleleft /> <!-- 左边组件 -->
    <buttomxp /> <!-- 下方导航按钮组件 -->
    <rightlittle /> <!-- 滑出组件 -->
    <rightlist /> <!-- 右边组件 -->
    <zyd /> <!-- 左下2按钮 -->
  </div>
</template>
<script>
import herder from "../components/dp/herder";
import littleleft from "../components/xp/left";
import buttomxp from "../components/xp/xpbuttom";
import rightlittle from "../components/xp/right.vue";
import rightlist from "../components/xp/rightlittle.vue";
import zyd from "../components/xp/colsts/zdy";
export default {
  name: "little",
  data() {
    return {};
  },
  components: {
    herder,
    littleleft,
    buttomxp,
    rightlittle,
    rightlist,
    zyd,
  },
};
</script>
<style lang="less" scoped>
</style>
